import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { result: String, id: Number }
  connect () {
    let klass = this.resultValue == 'success' ? 'bg-success' : 'bg-danger'

    document.querySelector(`[data-tip-id="${this.idValue}"]`).classList.add(klass, 'text-white')
  }
}
